import { FaFacebookF, FaLinkedinIn, FaInstagram, FaYoutube, FaMapMarkerAlt, FaPhone, FaEnvelope } from "react-icons/fa";
import { useNavigate, Link } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const handlePrivacyPolicy = () => {
      navigate("/PrivacyPolicy");
    };
  const handleTermsofService = () => {
      navigate("/TermsofService");
    };
      const handleSupport = () => {
      navigate("/Support");
    };
  return (
    // <footer className="relative bg-gradient-to-br from-[#00182e] via-[#002946] to-[#004e7c] text-white overflow-hidden">
    <footer className="relative bg-gradient-to-r from-[#000000] to-[#3533cd] text-white overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute top-10 left-10 w-80 h-80 bg-[#00d9ff] rounded-full filter blur-3xl opacity-5 animate-float"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-[#00d9ff] rounded-full filter blur-3xl opacity-5 animate-float animation-delay-2000"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-[#00d9ff] rounded-full filter blur-3xl opacity-3 animate-float animation-delay-4000"></div>
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-12">
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-4 mb-6">
              <div className="relative group">
                <div className="absolute -inset-2 bg-[#00d9ff] rounded-2xl blur-md opacity-20 group-hover:opacity-30 transition-opacity duration-500"></div>
                <Link to="/">
                <img
                  src="/images/orginal.png"
                  alt="Nexora Logo"
                  className="h-14 w-14 object-contain relative z-10 transform group-hover:scale-110 transition-transform duration-300"
                />
                </Link>
              </div>
              <div className="flex flex-col leading-tight">
                <Link to="/">
                <span className="text-2xl lg:text-3xl font-black bg-gradient-to-r from-white via-[#00d9ff] to-white bg-clip-text text-transparent bg-size-200 animate-gradient">
                  NEXORA
                </span>
                </Link>
                <Link to="/">
                <span className="text-sm lg:text-base text-blue-200 font-semibold tracking-wide">
                  Machinery
                </span>
                </Link>
              </div>
            </div>
            <p className="text-blue-100 text-base leading-relaxed mb-6 max-w-md font-light tracking-wide">
              Delivering top-quality industrial machinery and innovative trading solutions 
              with precision, reliability, and global standards.
            </p>
            <div className="flex space-x-3">
              {[
                { icon: <FaFacebookF className="text-sm" />, label: "Facebook", link: "https://www.facebook.com/share/1SRWD1auxM/"},
                { icon: <FaLinkedinIn className="text-sm" />, label: "LinkedIn", link: "https://www.linkedin.com/"},
                { icon: <FaInstagram className="text-sm" />, label: "Instagram", link: "https://www.instagram.com/invites/contact/?utm_source=ig_contact_invite&utm_medium=copy_link&utm_content=10q9pi6m"},
                { icon: <FaYoutube className="text-sm" />, label: "YouTube",link: "https://www.youtube.com/" }
              ].map((social, index) => (
                <a
                  key={index}
                  href={social.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group relative bg-white/5 backdrop-blur-lg rounded-xl w-11 h-11 flex items-center justify-center text-white transition-all duration-500 hover:bg-gradient-to-br hover:from-[#00d9ff] hover:to-[#0099cc] hover:scale-110 hover:shadow-xl border border-white/10 hover:border-[#00d9ff] shadow-lg hover:shadow-[#00d9ff]/20"
                  aria-label={social.label}
                >
                  <span className="relative z-10 transform group-hover:scale-110 transition-transform duration-300">
                    {social.icon}
                  </span>
                  <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-transparent rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </a>
              ))}
            </div>
          </div>
          <div>
            <h3 className="text-lg font-black mb-6 text-white relative inline-block pb-2">
              Quick Links
              <span className="absolute bottom-0 left-0 w-full h-0.5 bg-gradient-to-r from-[#00d9ff] via-white to-transparent rounded-full"></span>
            </h3>
            <ul className="space-y-3">
              {[
                { path: "/", label: "Home" },
                { path: "/Catloge", label: "Products" },
                { href: "/services", label: "Services" },
                { href: "/products", label: "Our Offerings" },
                { path: "/about", label: "About Us" },
                { href: "/contact", label: "Contact" }
              ].map((link, index) => (
                <li key={index}>
                  {link.path ? (
                    <Link 
                      to={link.path} 
                      className="group flex items-center gap-3 text-blue-100 hover:text-white transition-all duration-300 py-1.5 px-2 rounded-lg hover:bg-white/5"
                    >
                      <div className="w-1.5 h-1.5 bg-gradient-to-r from-[#00d9ff] to-[#0099cc] rounded-full transform scale-0 group-hover:scale-100 transition-transform duration-300 shadow-sm shadow-[#00d9ff]"></div>
                      <span className="text-sm font-medium group-hover:translate-x-1 transition-transform duration-300 tracking-wide">
                        {link.label}
                      </span>
                    </Link>
                  ) : (
                    <a 
                      href={link.href} 
                      className="group flex items-center gap-3 text-blue-100 hover:text-white transition-all duration-300 py-1.5 px-2 rounded-lg hover:bg-white/5"
                    >
                      <div className="w-1.5 h-1.5 bg-gradient-to-r from-[#00d9ff] to-[#0099cc] rounded-full transform scale-0 group-hover:scale-100 transition-transform duration-300 shadow-sm shadow-[#00d9ff]"></div>
                      <span className="text-sm font-medium group-hover:translate-x-1 transition-transform duration-300 tracking-wide">
                        {link.label}
                      </span>
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-black mb-6 text-white relative inline-block pb-2">
              Contact
              <span className="absolute bottom-0 left-0 w-full h-0.5 bg-gradient-to-r from-[#00d9ff] via-white to-transparent rounded-full"></span>
            </h3>
            <div className="space-y-4">
              <div className="group flex items-start gap-3 p-3 rounded-xl bg-white/5 backdrop-blur-sm border border-white/10 hover:border-[#00d9ff]/30 transition-all duration-500 hover:bg-white/10 hover:shadow-lg hover:shadow-[#00d9ff]/10">
                <div className="w-9 h-9 bg-gradient-to-br from-[#00d9ff] to-[#0099cc] rounded-lg flex items-center justify-center flex-shrink-0 transform group-hover:scale-110 transition-transform duration-300 shadow-md">
                  <FaMapMarkerAlt className="text-white text-xs" />
                </div>
                <p className="text-blue-100 text-sm leading-tight font-medium">
                  1/1, Elangovan Nager,
                  LIC First Street Back
                  Coimbatore, TamilNadu - 641021
                </p>
              </div>
              <div className="group flex items-center gap-3 p-3 rounded-xl bg-white/5 backdrop-blur-sm border border-white/10 hover:border-[#00d9ff]/30 transition-all duration-500 hover:bg-white/10 hover:shadow-lg hover:shadow-[#00d9ff]/10">
                <div className="w-9 h-9 bg-gradient-to-br from-[#00d9ff] to-[#0099cc] rounded-lg flex items-center justify-center flex-shrink-0 transform group-hover:scale-110 transition-transform duration-300 shadow-md">
                  <FaPhone className="text-white text-xs" />
                </div>
                <p className="text-blue-100 text-sm font-medium">+91 9150620187</p>
              </div>
              <div className="group flex items-start gap-3 p-3 rounded-xl bg-white/5 backdrop-blur-sm border border-white/10 hover:border-[#00d9ff]/30 transition-all duration-500 hover:bg-white/10 hover:shadow-lg hover:shadow-[#00d9ff]/10">
                <div className="w-9 h-9 bg-gradient-to-br from-[#00d9ff] to-[#0099cc] rounded-lg flex items-center justify-center flex-shrink-0 transform group-hover:scale-110 transition-transform duration-300 shadow-md">
                  <FaEnvelope className="text-white text-xs" />
                </div>
                <p className="text-blue-100 text-sm font-medium">saleshead@nexoramachinery.com</p>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-white/20 pt-6">
          <div className="flex flex-col lg:flex-row justify-between items-center gap-4">
            <p className="text-blue-200 text-xs lg:text-sm text-center lg:text-left font-light tracking-wide">
              © 2025 <span className="text-white font-black">Nexora Machinery</span> | All Rights Reserved.
            </p>
            <div className="flex gap-6 text-blue-200 text-xs lg:text-sm">
              <button onClick={handlePrivacyPolicy} className="hover:text-white transition-all duration-300 hover:scale-105 font-medium hover:drop-shadow-lg">Privacy Policy</button>
              <button onClick={handleTermsofService}className="hover:text-white transition-all duration-300 hover:scale-105 font-medium hover:drop-shadow-lg">Terms of Service</button>
              <button onClick={handleSupport} className="hover:text-white transition-all duration-300 hover:scale-105 font-medium hover:drop-shadow-lg">Support</button>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) scale(1); }
          50% { transform: translateY(-10px) scale(1.05); }
        }
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .animate-float {
          animation: float 8s ease-in-out infinite;
        }
        .animate-gradient {
          background-size: 200% 200%;
          animation: gradient 3s ease infinite;
        }
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        .animation-delay-4000 {
          animation-delay: 4s;
        }
        .bg-size-200 {
          background-size: 200% auto;
        }
      `}</style>
    </footer>
  );
};

export default Footer;